// removed by extract-text-webpack-plugin
module.exports = {"transaction-table-header":"transaction-table-header__d3uEH","transaction-header":"transaction-header__2GOKz","transactions-container":"transactions-container__3RZu6","scroll":"scroll__3EPF0","transaction-row":"transaction-row__fa0vf","p-bold":"p-bold__3IY0t","sticky-actions":"sticky-actions__HIVZc","columns":"columns__1GVyN"};


//////////////////
// WEBPACK FOOTER
// ./styles/dashboard/transactionTable.scss
// module id = 732
// module chunks = 68